import React, { useContext, useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { AppContext, UserContext } from 'commons-ui';
import { GAME_NAME } from 'commons/models/common';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import useList from '../useList';
import './input.css';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import DataInputView from '../dataInput';
import { EHomePageViewTranslatedCategory, IHomePageModifiedData, IHomePageTranslatedKeys } from '../../utils/constants';
import { completeViewDiv, headingStyle, margin20Px, onSubmitStyle } from '../../utils/style';

const HomePageV4View: React.FC = () => {
	const { getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getHomePageV4ViewData, handleConfirmSubmission, requestUpdateHomePageV4View, incCount } = useList();
	const [css] = useStyletron();

	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);

	const [viewKeys, setViewKeys] = useState<IHomePageTranslatedKeys>({} as IHomePageTranslatedKeys);
	const [homePageView, setHomePageView] = useState<IHomePageModifiedData>({} as IHomePageModifiedData);
	const [updatedHomePageView, setUpdatedHomePageView] = useState<IHomePageModifiedData>({} as IHomePageModifiedData);

	const fetchHomePageV4ViewConfig = async () => {
		try {
			const result: IHomePageModifiedData = await getHomePageV4ViewData();
			if (result && typeof result === 'object') {
				setViewKeys(result.viewKeys);
				setHomePageView(result);
			} else {
				showAlert(`invalid home page v4 config ${JSON.stringify(result)}`, { type: 'error' });
			}
		} catch (error) {
			showAlert(error, { type: 'error' });
		}
	};

	const handleSubmission = async () => {
		try {
			showAlert('Updating please wait');
			const homePageFinalView = handleConfirmSubmission(homePageView, updatedHomePageView);
			if (_isEmpty(homePageFinalView)) {
				showAlert('No changes found');
				return;
			}
			await requestUpdateHomePageV4View(app.appName, user, GAME_NAME.LUDO, homePageFinalView);
			showAlert('Request raised to update homepage config, pls ask somebody to approve');
		} catch (error) {
			showAlert('Unable to update home page v4 config', { type: 'error' });
		}
	};

	const handleOnUpdateClick = async () => {
		handleSubmission();
	};
	useEffect(() => {
		fetchHomePageV4ViewConfig();
	}, []);
	const validateView = () => {
		return viewKeys && viewKeys.segmentView && viewKeys.segmentView.length > 0 && homePageView && homePageView.segmentView;
	};

	return (
		<>
			<div className={css(completeViewDiv)}>
				{validateView() && (
					<div>
						{viewKeys.segmentView.map((viewKey) => {
							return (
								<div key={incCount()}>
									<h3 className={css(headingStyle)}>{viewKey}</h3>
									<DataInputView
										viewKey={viewKey}
										viewType={EHomePageViewTranslatedCategory.SEGMENT_VIEW}
										homePageView={homePageView}
										updatedHomePageView={updatedHomePageView}
										setUpdatedHomePageView={setUpdatedHomePageView}
									/>
								</div>
							);
						})}
					</div>
				)}
				{validateView() && (
					<div>
						{viewKeys.nonSegmentView.map((viewKey) => {
							return (
								<div key={incCount()}>
									<h3 className={css(headingStyle)}>{viewKey}</h3>
									<DataInputView
										viewKey={viewKey}
										viewType={EHomePageViewTranslatedCategory.NON_SEGMENT_VIEW}
										homePageView={homePageView}
										updatedHomePageView={updatedHomePageView}
										setUpdatedHomePageView={setUpdatedHomePageView}
									/>
								</div>
							);
						})}
					</div>
				)}
			</div>
			{actions.addAction.isEnabled() && (
				<div className={css(onSubmitStyle)}>
					<Button className={css(margin20Px)} onClick={handleOnUpdateClick}>
						Submit
					</Button>
				</div>
			)}
		</>
	);
};

export default HomePageV4View;
